// A booking nobody is on yet. The API names the empty crew "Assign Doctor" / "Assign Service
// Provider" / "Assign Crew" by industry (it never said "Assign Workers"), and a booking with a
// workflow also needs someone when a required step has nobody.
const UNASSIGNED_PLACEHOLDER = /^Assign (Doctor|Service Provider|Crew|Workers)$/;

export const needsAssignment = (item) =>
  UNASSIGNED_PLACEHOLDER.test(String(item?.provider_names || "").trim()) ||
  Number(item?.workflow_summary?.unassigned_required) > 0;

// The API's stand-in for "nobody yet" ("Assign Crew"...) is not a person: never show it as one.
export const isPlaceholderName = (name) => UNASSIGNED_PLACEHOLDER.test(String(name || "").trim());

// The people to show for a booking, with the placeholder taken out.
export const realProviderNames = (item) => (isPlaceholderName(item?.provider_names) ? "" : String(item?.provider_names || ""));

const CLOSED_STATUS = /^(cancel+ed|completed)$/;
export const isClosedBooking = (item) => CLOSED_STATUS.test(String(item?.booking_status || "").toLowerCase().replace(/[^a-z]/g, ""));

// Can a service provider be assigned from the list right now? The booking has no one in the service
// role (the service step of its workflow, or - without a workflow - the booking's provider) and is
// still open. Other workflow steps (a driver...) are assigned on the booking itself.
export const canAssignProvider = (item) => {
  if (!item?.group_id || isClosedBooking(item)) return false;
  const service = Array.isArray(item.step_assignments) ? item.step_assignments.find((s) => s.is_primary) : null;
  if (service) return !(service.people || []).length;
  return isPlaceholderName(item.provider_names);
};
